import { render } from "./AddPet.vue?vue&type=template&id=438b85a3&scoped=true"
import script from "./AddPet.vue?vue&type=script&lang=js"
export * from "./AddPet.vue?vue&type=script&lang=js"

import "./AddPet.vue?vue&type=style&index=0&id=438b85a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438b85a3"]])

export default __exports__